module.exports = __webpack_public_path__ + "img/arrow_up_default.1b2cd36d.svg";